var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2946 6.04167H10.4613V7.20833H11.6279V3.70833C11.6279 3.06667 11.1029 2.54167 10.4613 2.54167H9.87793V1.375H8.71126V2.54167H4.0446V1.375H2.87793V2.54167H2.2946C1.6471 2.54167 1.13376 3.06667 1.13376 3.70833L1.12793 11.875C1.12793 12.5167 1.6471 13.0417 2.2946 13.0417H6.37793V11.875H2.2946V6.04167ZM2.2946 3.70833H10.4613V4.875H2.2946V3.70833ZM12.7013 9.705L12.2871 10.1192L11.0504 8.8825L11.4646 8.46833C11.6921 8.24083 12.0596 8.24083 12.2871 8.46833L12.7013 8.8825C12.9288 9.11 12.9288 9.4775 12.7013 9.705ZM10.6363 9.29667L11.8729 10.5333L8.78126 13.625H7.5446V12.3883L10.6363 9.29667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCalendar);
export default __webpack_public_path__ + "static/media/EditCalendar.fc8aa06cfd7d237ccdac0d39de96068d.svg";
export { ForwardRef as ReactComponent };